
import request from '@/utils/request'
/*
npm菜单管理相关的API请求函数
*/
const api_name = '/admin/system/video/dsca'

export default {

    // 根据电话号码获取验证码  接口路径 /portal/web/api/member/register/code/{phone}
    sign() {
        return request({
            url: `${api_name}/sign`,
            method: 'get'
        })
    },


    find() {
        return request({
            url: `${api_name}/find`,
            method: 'get'
        })
    },
    submitApplication(application){
        return request({
            url: `${api_name}/save`,
            method: 'post',
            data: application
        })
    }

}
